import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { getDoc, doc, collection, DocumentSnapshot } from "firebase/firestore"
import { db } from "../firebase"
import { FormProps, StepForm } from "./lib/StepForm"

const IndividualRegistration = () => {
  const urlParams = useParams<{ individualId: string }>()
  const [values, setValues] = useState<Record<string, string|number>>({})
  const [forms, setForms] = useState<Array<FormProps>>([])
  const navigate = useNavigate()

  useEffect(() => {
    getDoc(doc(collection(db, 'forms'), 'individual')).then((_: DocumentSnapshot) => {
      _.exists() && setForms(_.data().conf.filter((form: FormProps) => form.isHunterElements))
    })
    const storageValues = sessionStorage.getItem('individual')
    if (storageValues) {
      setValues(JSON.parse(storageValues))
    }
    else {
      getDoc(doc(collection(db, 'individuals'), urlParams.individualId)).then((_: DocumentSnapshot) => {
        const data = _.data()
        if (data && data.status === "init") {
          setValues(data)
        }
        else {
          window.alert('既に個体情報は登録済みです')
          navigate('/')
        }
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSave = (values: Record<string, string | number>) => {
    setValues(values)
    sessionStorage.setItem('individual', JSON.stringify(values))
    navigate(`/individuals/${urlParams.individualId}/confirm`)
  }

  return (
    <StepForm values={values} forms={forms} onSave={onSave} />
  )
}

export default IndividualRegistration
